export default (str) => (
  str.replace(/[- ]+([a-z])/g, (g, g1) => g1.toUpperCase())
);
